/*============================================================
   REACT DEPENDENCIES
============================================================*/
import { useState, useEffect } from "react";

/*============================================================
   REDUX DEPENDENCIES
============================================================*/
import { useDispatch, useSelector } from "react-redux";

/*============================================================
  MATERIAL UI
============================================================*/
import FormGroup from "@mui/material/FormGroup";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
// import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

/*============================================================
  PROPRIETARY - COMPONENTS
============================================================*/
import GridSectionHeader from "../../widgets/GridSectionHeader";
import GridSection from "../../widgets/GridSection";
import GridCheckbox from "../../widgets/GridCheckbox";

/*============================================================
  PROPRIETARY - REDUX DATA SLICES
============================================================*/
import { updateClientInfo } from "../../../states/slcPersonalInformation.js";

/*============================================================
  PROPRIETARY - DATA MODELS
============================================================*/
import { createPersonalInfo } from "./PersonalInfoModel.js";

/*============================================================
  PROPRIETARY - UTILS
============================================================*/
import { createPayload, createReduxAction } from "../../../utils/modelHelper.js";

export default function SectionLanguages() {
  const currApplicant = useSelector((state) => state.app.currApplicant);
  const personalInfo = useSelector((state) => state.personalInformation[currApplicant]);

  const [spokenEnglish, setSpokenEnglish] = useState(personalInfo.spokenEnglish);
  const [spokenMandarin, setSpokenMandarin] = useState(personalInfo.spokenMandarin);
  const [spokenMalay, setSpokenMalay] = useState(personalInfo.spokenMalay);
  const [spokenTamil, setSpokenTamil] = useState(personalInfo.spokenTamil);
  const [spokenOthers, setSpokenOthers] = useState(personalInfo.spokenOthers);

  const [writtenEnglish, setWrittenEnglish] = useState(personalInfo.writtenEnglish);
  const [writtenMandarin, setWrittenMandarin] = useState(personalInfo.writtenMandarin);
  const [writtenMalay, setWrittenMalay] = useState(personalInfo.writtenMalay);
  const [writtenTamil, setWrittenTamil] = useState(personalInfo.writtenTamil);
  const [writtenOthers, setWrittenOthers] = useState(personalInfo.writtenOthers);

  // const [spokenLangs, setSpokenLanguages] = useState(["", "", "", "", ""]);
  // const [writtenLangs, setWrittenLanguages] = useState(["", "", "", "", ""]);

  // function handleSpokenLanguagesChange(e) {
  //   const newArr = [...spokenLangs];
  //   const selectedLanguage = e.target.value.toUpperCase();
  //   let index = 4;

  //   switch (selectedLanguage) {
  //     case "ENGLISH":
  //       index = 0;
  //       break;

  //     case "MANDRIN":
  //       index = 1;
  //       break;

  //     case "TAMIL":
  //       index = 2;
  //       break;

  //     case "MALAY":
  //       index = 3;
  //       break;

  //     default:
  //       index = 4;
  //   }

  //   newArr[index] = newArr[index] === "" ? selectedLanguage : "";
  //   setSpokenLanguages(newArr);
  // }

  // function handleWrittenLanguagesChange(e) {
  //   const newArr = [...writtenLangs];
  //   const selectedLanguage = e.target.value.toUpperCase();
  //   let index = 4;

  //   switch (selectedLanguage) {
  //     case "ENGLISH":
  //       index = 0;
  //       break;

  //     case "MANDRIN":
  //       index = 1;
  //       break;

  //     case "TAMIL":
  //       index = 2;
  //       break;

  //     case "MALAY":
  //       index = 3;
  //       break;

  //     default:
  //       index = 4;
  //   }

  //   newArr[index] = newArr[index] === "" ? selectedLanguage : "";
  //   setWrittenLanguages(newArr);
  // }

  const dispatch = useDispatch();

  //REFRESH COMPONENT WITH CURRENT APPLICANTE DATA
  useEffect(() => {
    setSpokenEnglish(personalInfo.spokenEnglish);
    setSpokenMandarin(personalInfo.spokenMandarin);
    setSpokenMalay(personalInfo.spokenMalay);
    setSpokenTamil(personalInfo.spokenTamil);
    setSpokenOthers(personalInfo.spokenOthers);

    setWrittenEnglish(personalInfo.writtenEnglish);
    setWrittenMandarin(personalInfo.writtenMandarin);
    setWrittenMalay(personalInfo.writtenMalay);
    setWrittenTamil(personalInfo.writtenTamil);
    setWrittenOthers(personalInfo.writtenOthers);
  }, [currApplicant]);

  function handleChange(e, object) {
    let id = e.target.id;

    let actionType = "";
    let updateAction = null;
    let payload = null;

    const personalInfo = createPersonalInfo();

    if (id === "spokenEnglish") {
      personalInfo.spokenEnglish = e.target.checked;
      setSpokenEnglish(e.target.checked);
      actionType = "UPDATE_SPOKEN_ENGLISH";
    }

    if (id === "spokenMandarin") {
      personalInfo.spokenMandarin = e.target.checked;
      setSpokenMandarin(e.target.checked);
      actionType = "UPDATE_SPOKEN_MANDARIN";
    }

    if (id === "spokenMalay") {
      personalInfo.spokenMalay = e.target.checked;
      setSpokenMalay(e.target.checked);
      actionType = "UPDATE_SPOKEN_MALAY";
    }

    if (id === "spokenTamil") {
      personalInfo.spokenTamil = e.target.checked;
      setSpokenTamil(e.target.checked);
      actionType = "UPDATE_SPOKEN_TAMIL";
    }

    if (id === "spokenOthers") {
      personalInfo.spokenOthers = e.target.checked;
      setSpokenOthers(e.target.checked);
      actionType = "UPDATE_SPOKEN_OTHERS";
    }

    if (id === "writtenEnglish") {
      personalInfo.writtenEnglish = e.target.checked;
      setWrittenEnglish(e.target.checked);
      actionType = "UPDATE_WRITTEN_ENGLISH";
    }

    if (id === "writtenMandarin") {
      personalInfo.writtenMandarin = e.target.checked;
      setWrittenMandarin(e.target.checked);
      actionType = "UPDATE_WRITTEN_MANDARIN";
    }

    if (id === "writtenMalay") {
      personalInfo.writtenMalay = e.target.checked;
      setWrittenMalay(e.target.checked);
      actionType = "UPDATE_WRITTEN_MALAY";
    }

    if (id === "writtenTamil") {
      personalInfo.writtenTamil = e.target.checked;
      setWrittenTamil(e.target.checked);
      actionType = "UPDATE_WRITTEN_TAMIL";
    }

    if (id === "writtenOthers") {
      personalInfo.writtenOthers = e.target.checked;
      setWrittenOthers(e.target.checked);
      actionType = "UPDATE_WRITTEN_OTHERS";
    }

    payload = createPayload(currApplicant, personalInfo);
    updateAction = createReduxAction(actionType, payload);
    dispatch(updateClientInfo(updateAction));
  }

  return (
    <Grid container spacing={2}>
      <GridSectionHeader sectionName="Languages" />

      <GridSection columnSize={12}>
        {/*==============================
          SPOKEN LANGUAGES
         ==============================*/}
        <Typography variant="body1">Conversant in Spoken Languages (Tick all that apply)</Typography>
        <FormGroup row>
          <GridCheckbox
            id="spokenEnglish"
            columnSize="2"
            label="English"
            checked={spokenEnglish}
            disabled={false}
            onChange={handleChange}
          />
          <GridCheckbox
            id="spokenMandarin"
            columnSize="2"
            label="Mandrin"
            checked={spokenMandarin}
            disabled={false}
            onChange={handleChange}
          />
          <GridCheckbox
            id="spokenMalay"
            columnSize="2"
            label="Malay"
            checked={spokenMalay}
            disabled={false}
            onChange={handleChange}
          />
          <GridCheckbox
            id="spokenTamil"
            columnSize="2"
            label="Tamil"
            checked={spokenTamil}
            disabled={false}
            onChange={handleChange}
          />
          <GridCheckbox
            id="spokenOthers"
            columnSize="2"
            label="Others"
            checked={spokenOthers}
            disabled={false}
            onChange={handleChange}
          />
        </FormGroup>

        {/*==============================
          WRITTEN LANGUAGES
         ==============================*/}
        <Typography variant="body1">Proficiency in Written Languages (Tick all that apply)</Typography>

        <FormGroup row>
          <GridCheckbox
            id="writtenEnglish"
            columnSize="2"
            label="English"
            checked={writtenEnglish}
            disabled={false}
            onChange={handleChange}
          />
          <GridCheckbox
            id="writtenMandarin"
            columnSize="2"
            label="Mandrin"
            checked={writtenMandarin}
            disabled={false}
            onChange={handleChange}
          />
          <GridCheckbox
            id="writtenMalay"
            columnSize="2"
            label="Malay"
            checked={writtenMalay}
            disabled={false}
            onChange={handleChange}
          />
          <GridCheckbox
            id="writtenTamil"
            columnSize="2"
            label="Tamil"
            checked={writtenTamil}
            disabled={false}
            onChange={handleChange}
          />
          <GridCheckbox
            id="writtenOthers"
            columnSize="2"
            label="Others"
            checked={writtenOthers}
            disabled={false}
            onChange={handleChange}
          />
        </FormGroup>
      </GridSection>
    </Grid>
  );
}
